<template>
  <div
      style="position: relative; height: 300px;width: 300px;"
  >
    <template
        v-for="image in images"
        :key="image.id"
    >
      <img
          :style="imageStyles(image)"
          :data-extra-class="image.extraClass"
          :data-layer="image.id"
          :class="['tw-product-img', image.extraClass]"
          :src="image.image"
          oncontextmenu="return false;"
          draggable="false"
          @load="onImageLoad"
      >
    </template>
  </div>
</template>

<script>
export default {
  name: "ImageLayeringWithProps",
  props: {
    images: {
      type: Array,
      required: true,
      default: () => [],
      validator: (images) => {
        // Validate that each image has the required properties
        return images.every(image =>
          image.id !== undefined &&
          image.image !== undefined
        );
      }
    },
    selectedVariant: {
      type: Object,
      default: () => ({
        image_zoom: 1
      })
    }
  },
  data() {
    return {
      imageHeight: 450
    }
  },
  watch: {
    // Watch for changes in images prop to recalculate height if needed
    images: {
      handler() {
        this.$nextTick(() => {
          this.measureImageHeight()
        })
      },
      deep: true
    },
    // Watch for zoom changes
    'selectedVariant.image_zoom'() {
      this.$nextTick(() => {
        this.measureImageHeight()
      })
    }
  },
  methods: {
    imageStyles(image) {
      let transform = '';
      let margin = 0;

      if (image.flipped) {
        transform += 'scaleX(-1) ';
      }

      if (this.selectedVariant.image_zoom && this.selectedVariant.image_zoom !== 1) {
        transform += `scale(${this.selectedVariant.image_zoom}) `;
        margin = ((this.selectedVariant.image_zoom - 1) * 100) + 10;
      }

      transform += 'translate(-50%, -50%)'

      return {
        marginTop: `${margin}px`, // Ensure margin is a valid CSS value
        zIndex: image.zindex,
        transform: transform.trim(),
        transformOrigin: 'left'
      };
    },
    measureImageHeight() {
      const img = document.querySelector('.tw-product-img')
      if (img) {
        this.imageHeight = img.clientHeight

        if (this.selectedVariant.image_zoom && this.selectedVariant.image_zoom !== 1) {
          this.imageHeight = this.imageHeight * this.selectedVariant.image_zoom;
          this.imageHeight += 50
        }
      }
    },
    onImageLoad() {
      this.$nextTick(() => {
        this.measureImageHeight()
      })
    }
  }
}
</script>

<style scoped>
.tw-product-img {
  max-height: 500px;
  max-width: 90%;
  position: absolute;
  text-align: center;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

#image-container {
  height: 100vh;
}
</style>
